import { useEffect, useState } from 'react';
import { useUserStore } from '@citiguide/frontend-core';
import { LatLngTuple } from 'leaflet';

interface GeolocationState {
  location: LatLngTuple | null;
  error: GeolocationPositionError | null;
  loading: boolean;
}

export const useGeolocation = (enabled: boolean = true) => {
  const [state, setState] = useState<GeolocationState>({
    location: null,
    error: null,
    loading: false,
  });
  const { setLocation, setTrackingLocation } = useUserStore();

  useEffect(() => {
    if (!enabled || !navigator.geolocation) {
      return;
    }

    setState((prev) => ({ ...prev, loading: true }));
    setTrackingLocation(true);

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        const newLocation: LatLngTuple = [
          position.coords.latitude,
          position.coords.longitude,
        ];
        setState({
          location: newLocation,
          error: null,
          loading: false,
        });
        setLocation(newLocation);
      },
      (error) => {
        setState({
          location: null,
          error,
          loading: false,
        });
        setTrackingLocation(false);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 5000,
        timeout: 10000,
      }
    );

    return () => {
      navigator.geolocation.clearWatch(watchId);
      setTrackingLocation(false);
    };
  }, [enabled, setLocation, setTrackingLocation]);

  return state;
};

